export function getSelectOptionsForSchools({schools}) {
  return schools.options.map(school => ({
    value: school.id,
    label: school.name
  }));
}

export function getSelectOptionsForPeople({people}) {
  const staffOptions = people.options.staffs.map(staff => ({
    group: 'staffs',
    value: staff.id,
    label: staff.name
  }));

  const teacherOptions = people.options.teachers.map(teacher => ({
    group: 'teachers',
    value: teacher.id,
    label: teacher.name
  }));

  return [...staffOptions, ...teacherOptions];
}

export function getSelectOptionsForTools({tools}) {
  let toolOptions = [];
  for (const toolTypeId in tools.options) {
    if (!tools.options.hasOwnProperty(toolTypeId)) {
      continue;
    }

    toolOptions = [...toolOptions, tools.options[toolTypeId].map(tool => ({
      group: toolTypeId,
      value: tool.id,
      label: tool.name
    }))];
  }

    let i=0; while (i < toolOptions.length) {
      if (toolOptions[i][0].group === '900') {
        let a = toolOptions.splice(i, 1);
        toolOptions.unshift(a[0]);
      }
      i++;
    }
    return toolOptions;
}

export function getSelectOptionsForDepartments({departments}) {
  return departments.options.map(department => ({
    value: department.id,
    label: department.name
  }));
}

export function getSelectOptionsForGrades({grades}) {
  return grades.options.map(grade => ({
    value: grade.id,
    label: grade.name
  }));
}

